import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import type React from 'react';
import { type KeyboardEventHandler, type MouseEventHandler, memo } from 'react';
import CPProyectionIcon from '/@/components/icon/assets/crop-proyection.svg?raw';
import HandCheckIcon from '/@/components/icon/assets/hand_with_check.svg?raw';
import Agronomy from './assets/agronomy.svg?raw';
import AgronomyCheckup from './assets/agronomy_checkup.svg?raw';
import AirIcon from './assets/air.svg?raw';
import AlertIcon from './assets/alert.svg?raw';
import Arrow from './assets/arrow.svg?raw';
import ConsultApps from './assets/ask-an-expert/apps.svg?raw';
import Cereal from './assets/ask-an-expert/cereal.svg?raw';
import Clip from './assets/ask-an-expert/clip.svg?raw';
import ConsultCorn from './assets/ask-an-expert/corn.svg?raw';
import HowItWorks from './assets/ask-an-expert/how-it-works.svg?raw';
import Intacta from './assets/ask-an-expert/intacta.svg?raw';
import NotSent from './assets/ask-an-expert/not-sent.svg?raw';
import Others from './assets/ask-an-expert/others.svg?raw';
import Pen from './assets/ask-an-expert/pen.svg?raw';
import Pests from './assets/ask-an-expert/pests.svg?raw';
import Problem from './assets/ask-an-expert/problem.svg?raw';
import Sent from './assets/ask-an-expert/sent.svg?raw';
import ConsultSoy from './assets/ask-an-expert/soy.svg?raw';
import Vtpro4 from './assets/ask-an-expert/vtpro4.svg?raw';
import ConsultWeeds from './assets/ask-an-expert/weeds.svg?raw';
import Y2X from './assets/ask-an-expert/y2x.svg?raw';
import BarleyIcon from './assets/barley.svg?raw';
import Bayer from './assets/bayer.svg?raw';
import BugIcon from './assets/bug.svg?raw';
import BugIcon2 from './assets/bug2.svg?raw';
import CircleSpodoptera from './assets/CircleSpodoptera.svg?raw';
import Calculator from './assets/calculator.svg?raw';
import Caracteristics from './assets/caracteristics.svg?raw';
import Carbon from './assets/carbon.svg?raw';
import Catalogue from './assets/catalogue.svg?raw';
import Check from './assets/check.svg?raw';
import Check2 from './assets/check2.svg?raw';
import ChemicalIcon from './assets/chemical.svg?raw';
import Close from './assets/close.svg?raw';
import Close2 from './assets/close_2.svg?raw';
import Copy from './assets/copy.svg?raw';
import CornIcon from './assets/corn.svg?raw';
import CornCalculator from './assets/corn-calculator.svg?raw';
import CornNew from './assets/corn-new.svg?raw';
import CornRecoPlus from './assets/corn-reco-plus.svg?raw';
import CornRecommendation from './assets/corn-recommendation.svg?raw';
import CornDensityRecommendation from './assets/cornDensityRecommendation.svg?raw';
import diseaseRecommendation from './assets/cp-diseases.svg?raw';
import CPPests from './assets/cp-pests.svg?raw';
import CPWeeds from './assets/cp-weeds.svg?raw';
import CropProtection from './assets/crop-protection.svg?raw';
import ChemicalFallowIcon from './assets/crop-stages/chemical-fallow.svg?raw';
import CoverageIcon from './assets/crop-stages/coverage.svg?raw';
import PlantingCornIcon from './assets/crop-stages/planting-corn.svg?raw';
import PlantingCottonIcon from './assets/crop-stages/planting-cotton.svg?raw';
import PlantingOatIcon from './assets/crop-stages/planting-oat.svg?raw';
import PlantingSorghumIcon from './assets/crop-stages/planting-sorghum.svg?raw';
import PlantingSoyIcon from './assets/crop-stages/planting-soy.svg?raw';
import PlantingWheatIcon from './assets/crop-stages/planting-wheat.svg?raw';
import PostharvestIcon from './assets/crop-stages/postharvest.svg?raw';
import PreharvestIcon from './assets/crop-stages/preharvest.svg?raw';
import PreplantingIcon from './assets/crop-stages/preplanting.svg?raw';
import VegetativeCornIcon from './assets/crop-stages/vegetative-corn.svg?raw';
import VegetativeCottonIcon from './assets/crop-stages/vegetative-cotton.svg?raw';
import VegetativeOatIcon from './assets/crop-stages/vegetative-oat.svg?raw';
import VegetativeSorghumIcon from './assets/crop-stages/vegetative-sorghum.svg?raw';
import VegetativeSoyIcon from './assets/crop-stages/vegetative-soy.svg?raw';
import VegetativeWheatIcon from './assets/crop-stages/vegetative-wheat.svg?raw';
import CropMonitoring from './assets/cropMonitoring.svg?raw';
import Cross from './assets/cross.svg?raw';
import Dots from './assets/Dots.svg?raw';
import DefensiveProfile from './assets/defensive-profile.svg?raw';
import DensityIcon from './assets/density.svg?raw';
import DiseaseIcon from './assets/disease.svg?raw';
import DiseasesIcon from './assets/diseases.svg?raw';
import Download from './assets/download2.svg?raw';
import Email from './assets/email.svg?raw';
import FertilizationIcon from './assets/fertilization.svg?raw';
import Fields from './assets/fields.svg?raw';
import Fields2 from './assets/fields2.svg?raw';
import FieldviewIcon from './assets/fieldview-icon.svg?raw';
import FitosanitaryIcon from './assets/fitosanitary.svg?raw';
import Frost from './assets/frost.svg?raw';
import FrostRisk from './assets/frost-risk.svg?raw';
import Grass from './assets/grass.svg?raw';
import HumidityCircle from './assets/HumidityCircle.svg?raw';
import HarvestIcon from './assets/harvest.svg?raw';
import HerbicideIcon from './assets/herbicide.svg?raw';
import HumidityIcon from './assets/humidity.svg?raw';
import HumidityVector from './assets/humidity_vector.svg?raw';
import Humidity2Icon from './assets/humidity2.svg?raw';
import Humidity3 from './assets/humidity3.svg?raw';
import IconDocument from './assets/icon-document.svg?raw';
import NewField from './assets/icon-new-field.svg?raw';
import Info from './assets/info.svg?raw';
import Info2 from './assets/info2.svg?raw';
import LeafIcon from './assets/leaf.svg?raw';
import Library from './assets/library.svg?raw';
import Maps from './assets/maps.svg?raw';
import Meteorology from './assets/meteorology.svg?raw';
import myRecosIcon from './assets/my-recos.svg?raw';
import Nitrogen from './assets/nitrogen.svg?raw';
import Offline from './assets/offline.svg?raw';
import PestIcon from './assets/pest.svg?raw';
import PhenologyIcon from './assets/phenology.svg?raw';
import PlantingDatesIcon from './assets/planting-dates.svg?raw';
import PlantingWindowIcon from './assets/planting-window.svg?raw';
import Plus from './assets/plus.svg?raw';
import PrecipitationVector from './assets/precipitation_vector.svg?raw';
import ProductDatasheet from './assets/product-datasheet.svg?raw';
import Ptv from './assets/ptv.svg?raw';
import RainIcon from './assets/rain.svg?raw';
import RecommendationCheckIcon from './assets/recommendation-check.svg?raw';
import Red from './assets/red.svg?raw';
import RefugeIcon from './assets/refuge.svg?raw';
import Register from './assets/register.svg?raw';
import RingBell from './assets/ringBell.svg?raw';
import SeedBag from './assets/seed-bag.svg?raw';
import SoyIcon from './assets/soy.svg?raw';
import SoyIcon2 from './assets/soy2.svg?raw';
import Statistics from './assets/statistics.svg?raw';
import SunIcon from './assets/sun.svg?raw';
import TechBag from './assets/techBag.svg?raw';
import TemperatureVector from './assets/temperature_vector.svg?raw';
import TemperatureHot from './assets/temperatureHot.svg?raw';
import Weather from './assets/weather.svg?raw';
import WeedsIcon from './assets/weeds.svg?raw';
import WhatsappIcon from './assets/whatsapp2.svg?raw';
import WheatIcon from './assets/wheat.svg?raw';
import WindVector from './assets/wind_vector.svg?raw';

import styles from './styles.module.css';

const icons = {
    alert: { __html: AlertIcon },
    chemical: { __html: ChemicalIcon },
    myRecos: { __html: myRecosIcon },
    corn: { __html: CornIcon },
    fitosanitary: { __html: FitosanitaryIcon },
    cornCalculator: { __html: CornCalculator },
    density: { __html: DensityIcon },
    disease: { __html: DiseaseIcon },
    fertilization: { __html: FertilizationIcon },
    pest: { __html: PestIcon },
    phenology: { __html: PhenologyIcon },
    plantingDates: { __html: PlantingDatesIcon },
    defensiveProfile: { __html: DefensiveProfile },
    caracteristics: { __html: Caracteristics },
    refuge: { __html: RefugeIcon },
    soy: { __html: SoyIcon },
    soy2: { __html: SoyIcon2 },
    wheat: { __html: WheatIcon },
    barley: { __html: BarleyIcon },
    weeds: { __html: WeedsIcon },
    bug: { __html: BugIcon },
    diseases: { __html: DiseasesIcon },
    humidity: { __html: HumidityIcon },
    humidity2: { __html: Humidity2Icon },
    sun: { __html: SunIcon },
    rain: { __html: RainIcon },
    air: { __html: AirIcon },
    whatsapp: { __html: WhatsappIcon },
    leaf: { __html: LeafIcon },
    chemicalFallow: { __html: ChemicalFallowIcon },
    coverage: { __html: CoverageIcon },
    preplanting: { __html: PreplantingIcon },
    preharvest: { __html: PreharvestIcon },
    postharvest: { __html: PostharvestIcon },
    plantingCorn: { __html: PlantingCornIcon },
    plantingWindow: { __html: PlantingWindowIcon },
    plantingCotton: { __html: PlantingCottonIcon },
    plantingOat: { __html: PlantingOatIcon },
    plantingSorghum: { __html: PlantingSorghumIcon },
    plantingSoy: { __html: PlantingSoyIcon },
    plantingWheat: { __html: PlantingWheatIcon },
    vegetativeCorn: { __html: VegetativeCornIcon },
    vegetativeCotton: { __html: VegetativeCottonIcon },
    vegetativeOat: { __html: VegetativeOatIcon },
    ptv: { __html: Ptv },
    vegetativeSorghum: { __html: VegetativeSorghumIcon },
    vegetativeSoy: { __html: VegetativeSoyIcon },
    vegetativeWheat: { __html: VegetativeWheatIcon },
    crop_protection: { __html: ChemicalIcon },
    harvest: { __html: HarvestIcon },
    download: { __html: Download },
    email: { __html: Email },
    consultApps: { __html: ConsultApps },
    cereal: { __html: Cereal },
    consultCorn: { __html: ConsultCorn },
    pests: { __html: Pests },
    consultSoy: { __html: ConsultSoy },
    consultWeeds: { __html: ConsultWeeds },
    others: { __html: Others },
    pen: { __html: Pen },
    clip: { __html: Clip },
    sent: { __html: Sent },
    notSent: { __html: NotSent },
    vtpro4: { __html: Vtpro4 },
    howItWorks: { __html: HowItWorks },
    problem: { __html: Problem },
    y2x: { __html: Y2X },
    info: { __html: Info },
    info2: { __html: Info2 },
    intacta: { __html: Intacta },
    techBag: { __html: TechBag },
    weather: { __html: Weather },
    meteorology: { __html: Meteorology },
    library: { __html: Library },
    catalogue: { __html: Catalogue },
    maps: { __html: Maps },
    red: { __html: Red },
    nitrogen: { __html: Nitrogen },
    carbon: { __html: Carbon },
    productDatasheet: { __html: ProductDatasheet },
    arrow: { __html: Arrow },
    plus: { __html: Plus },
    fields: { __html: Fields },
    fields2: { __html: Fields2 },
    close: { __html: Close },
    dots: { __html: Dots },
    offline: { __html: Offline },
    diseaseRecommendation: { __html: diseaseRecommendation },
    humidityCircle: { __html: HumidityCircle },
    circleSpodoptera: { __html: CircleSpodoptera },
    close2: { __html: Close2 },
    register: { __html: Register },
    newField: { __html: NewField },
    iconDocument: { __html: IconDocument },
    check: { __html: Check },
    check2: { __html: Check2 },
    copy: { __html: Copy },
    cropMonitoring: { __html: CropMonitoring },
    statistics: { __html: Statistics },
    ringBell: { __html: RingBell },
    temperatureHot: { __html: TemperatureHot },
    calculator: { __html: Calculator },
    cornRecoPlus: { __html: CornRecoPlus },
    cross: { __html: Cross },
    bayer: { __html: Bayer },
    humidityVector: { __html: HumidityVector },
    precipitationVector: { __html: PrecipitationVector },
    temperatureVector: { __html: TemperatureVector },
    windVector: { __html: WindVector },
    frostRisk: { __html: FrostRisk },
    frost: { __html: Frost },
    weedRecommendation: { __html: CPWeeds },
    cornRecommendation: { __html: CornRecommendation },
    plagueRecommendation: { __html: CPPests },
    agronomyCheckup: { __html: AgronomyCheckup },
    agronomy: { __html: Agronomy },
    grass: { __html: Grass },
    humidity3: { __html: Humidity3 },
    seedBag: { __html: SeedBag },
    cropProyection: { __html: CPProyectionIcon },
    handCheck: { __html: HandCheckIcon },
    cropProtection: { __html: CropProtection },
    cornNew: { __html: CornNew },
    cornDensityRecommendation: { __html: CornDensityRecommendation },
    soyRecommendation: { __html: SoyIcon2 },
    recommendationCheck: { __html: RecommendationCheckIcon },
    fieldview: { __html: FieldviewIcon },
    herbicide: { __html: HerbicideIcon },
    weedV2: { __html: BugIcon2 },
} as const;

// Type definitions
export type IconType = keyof typeof icons;
export type IconSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export type IconContainer = 'circle';
export type IconVariant = 'primary' | 'secondary' | 'accent';

export interface IconProps {
    type: IconType;
    size?: IconSize;
    theme?: string;
    container?: IconContainer;
    padding?: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
    className?: string;
    style?: React.CSSProperties;
    tooltip?: boolean;
    tooltipText?: string;
    variant?: IconVariant;
    sx?: object;
    'aria-label'?: string;
    role?: string;
}

const Icon: React.FC<IconProps> = memo(
    ({
        type,
        size,
        theme,
        container,
        padding = true,
        onClick,
        className,
        style,
        variant = 'primary',
        sx,
        tooltip = false,
        tooltipText,
        'aria-label': ariaLabel,
        role,
    }) => {
        const rootClassNames = classNames(
            styles.root,
            size && styles[`size-${size}`],
            theme && styles[`theme-${theme}-${variant}`],
            container && styles[`container-${container}`],
            padding && styles.padding,
            className
        );

        const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
            }
        };

        const iconElement = (
            <Box
                // biome-ignore lint: SVG icons are safe static content
                dangerouslySetInnerHTML={icons[type]}
                role={role || (onClick ? 'button' : 'img')}
                sx={{
                    display: 'flex',
                }}
            />
        );

        return (
            <Box
                className={rootClassNames}
                onClick={onClick}
                style={style}
                sx={[
                    sx,
                    variant && {
                        '& svg *': {
                            fill: (t) => (theme ? undefined : style?.fill || sx?.fill || t.palette[variant].main),
                            borderColor: (t) =>
                                theme ? undefined : style?.fill || sx?.fill || t.palette[variant].main,
                        },
                    },
                ]}
                role={onClick ? 'button' : undefined}
                tabIndex={onClick ? 0 : undefined}
                onKeyDown={onClick ? handleKeyDown : undefined}
                aria-label={ariaLabel}
            >
                {tooltip && tooltipText ? (
                    <Tooltip arrow title={tooltipText}>
                        {iconElement}
                    </Tooltip>
                ) : (
                    iconElement
                )}
            </Box>
        );
    }
);

Icon.displayName = 'Icon';

export default Icon;
